import { Observable } from "rxjs"
import EmploymentDetailsEdit from "./RandomPersonnelModel/EmploymentDetailsEdit"
import { ObservableFromFetch } from "../ObservableFromFetch"
import { GetUserId } from "../../storage/UserId"
import { UpdateMethodID } from "../../config/Constants"

export default function RandomPersonnelAdd(data: EmploymentDetailsEdit): Observable<string> {
  const urlParams: string = new URLSearchParams({
    loginID: `${GetUserId()}`,
    updateMethodID: UpdateMethodID.toString()
  }).toString()
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("/RandomTest/AddPerson?" + urlParams, requestBody)
}